module.exports = __webpack_public_path__ + "media/images/icons/ic-textfield-delete-f36e0fb2d0ac98c6dda062ccf1951d91.svg";